import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ size = 'lg', text = 'Chargement...', variant = 'primary' }) => {
  return (
    <div className="loading-spinner-container">
      <div className="loading-content">
        <Spinner 
          animation="border" 
          variant={variant}
          size={size}
          className="mb-3"
        />
        <div className="loading-text">{text}</div>
      </div>
      
      <style jsx>{`
        .loading-spinner-container {
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 200px;
          width: 100%;
        }

        .loading-content {
          text-align: center;
          padding: 2rem;
        }

        .loading-text {
          color: #64748b;
          font-size: 1rem;
          font-weight: 500;
          margin-top: 1rem;
        }

        /* Animation personnalisée */
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }

        .loading-text {
          animation: pulse 2s ease-in-out infinite;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .loading-content {
            padding: 1rem;
          }
          
          .loading-text {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;